import { Buffer } from 'buffer';
import { Chart } from 'chart.js';
import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { flipY2TitlePlugin } from './App/Routes/Analytics/utils/flipY2TitlePlugin';

globalThis.Buffer = globalThis.Buffer || Buffer;
Chart.register(flipY2TitlePlugin);

const root = createRoot(document.getElementById('root'));
root.render(<App />);

// Remove existing service worker, NB! Can be removed afterwards
if (window.navigator && navigator.serviceWorker) {
    navigator.serviceWorker.getRegistrations().then(function unRegisterAll(registrations) {
        for (const registration of registrations) {
            registration.unregister();
        }
    });
}
